import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { DomHandler } from 'primeng/dom';

@Component({
  selector: 'app-block-screen',
  templateUrl: './block-screen.component.html',
  styleUrls: ['./block-screen.component.css'],
  providers: [DomHandler]
})
export class BlockScreenComponent implements OnInit {

  /*
     Block Screen / Loader component :
     Controlled via Global Service [src\app\service\globalService.ts]
     Functions to use: setLoadingOn() and setLoadingOff()
  */

  @ViewChild('mask') mask: ElementRef;
  _blocked: boolean;

  constructor() { }

  ngOnInit() {
  }

  @Input() get blocked(): boolean {
    return this._blocked;
  }

  set blocked(val: boolean) {
    if (val) {
      //document.body.appendChild(this.mask.nativeElement);
      this.mask.nativeElement.style.zIndex = String(++DomHandler.zindex);
    }
    this._blocked = val;
  }
}
